import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../icons/icon'

const CloseButton = props => {
  return (
    <button className='close-button' onClick={props.onClick}>
      <Icon name='close' />
    </button>
  )
}

CloseButton.propTypes = {
  onClick: PropTypes.func
}

export default CloseButton



// WEBPACK FOOTER //
// ./src/ui/buttons/close-button.js